// Village Configuration for 135 Villages
// This maps domains to their respective clientIds and configurations

const VILLAGE_CONFIGS = {

'chikhaligrampanchayat.in': {
    clientId: 1,
    villageName: 'चिखली',
    englishName: 'Grampanchayat Chikhali',
    theme: { primaryColor: '#3C9718', lightBg: '#EDF7E6', darkColor: '#044400' },
    officeInfo: {
      officeName: 'ग्राम पंचायत कार्यालय',
      addressLine1: 'मु. पो. चिखली ता. गुहागर जि. रत्नागिरी',
      addressLine2: '',
      phones: ['+91 7219001956'],
      email: 'gp.chikhali1956@gmail.com',
      hours: ['सकाळी ९.१५ ते संध्याकाळी ६.१५'],
      imageUrl: 'office.jpg'
    }
    },
'adur.in': {
    clientId: 2,
    villageName: 'अडुर',
    englishName: 'Adur',
    theme: { primaryColor: '#994318', lightBg: '#F4EBE6', darkColor: '#421600' },
    officeInfo: {
      officeName: 'ग्राम पंचायत कार्यालय',
      addressLine1: 'अडुर, ता.गुहागर, जि.रत्नागिरी',
      addressLine2: '',
      phones: [''],
      email: '',
      hours: ['सकाळी ९.४५ ते सायं. ०६.१५ (शनिवार, रविवार व शासकीय सुट्टीचे वर वगळून)']
    }
    },
    
  'abloli.in': {
    clientId: 3,
    villageName: 'आबलोली',
    englishName: 'Abloli',
    theme: { primaryColor: '#994E18', lightBg: '#F4ECE6', darkColor: '#421B00' },
    officeInfo: {
      officeName: 'ग्राम पंचायत कार्यालय',
      addressLine1: 'आबलोली, ता.गुहागर, जि.रत्नागिरी पिन. ४१५७२६',
      addressLine2: '',
      phones: ['७०५७६१४७३९'],
      email: 'grampanchayatabloli@gmail.com',
      hours: ['सकाळी ९.४५ ते सायं. ०६.१५ (शनिवार, रविवार व शासकीय सुट्टीचे वर वगळून)'],
      imageUrl: 'abloli/abloliOfficeBuilding.jpg'
    }
  },
  'are-waki-pimpalwat.in': {
    clientId: 4,
    villageName: 'आरे-वाकी-पिंपळवट',
    englishName: 'Are-Waki-Pimpalwat',
    theme: { primaryColor: '#995818', lightBg: '#F4EDE6', darkColor: '#422100' }
  },
  'anjanwel.in': {
    clientId: 5,
    villageName: 'अंजनवेल',
    englishName: 'Anjanwel',
    theme: { primaryColor: '#996318', lightBg: '#F4EEE6', darkColor: '#422600' }
  },
  'amberekhurd.in': {
    clientId: 6,
    villageName: 'आंबेरे खुर्द',
    englishName: 'Ambere Khurd',
    theme: { primaryColor: '#996E18', lightBg: '#F4EFE6', darkColor: '#422C00' }
  },
  'umarath.in': {
    clientId: 7,
    villageName: 'उमराठ',
    englishName: 'Umarath',
    theme: { primaryColor: '#997818', lightBg: '#F4F1E6', darkColor: '#423100' }
  },
  'aware-asore.in': {
    clientId: 8,
    villageName: 'आवरे-असोरे',
    englishName: 'Aware-Asore',
    theme: { primaryColor: '#998318', lightBg: '#F4F2E6', darkColor: '#423700' }
  },
  'kajurli.in': {
    clientId: 9,
    villageName: 'काजुर्ली',
    englishName: 'Kajurli',
    theme: { primaryColor: '#998E18', lightBg: '#F4F3E6', darkColor: '#423C00' }
  },
  'katale.in': {
    clientId: 10,
    villageName: 'काताळे',
    englishName: 'Katale',
    theme: { primaryColor: '#999918', lightBg: '#F4F4E6', darkColor: '#424200' }
  },
  'grampanchayatkarul.in': {
    clientId: 11,
    villageName: 'कारुळ',
    englishName: 'Karul',
    theme: { primaryColor: '#8E9918', lightBg: '#F3F4E6', darkColor: '#3C4200' }
  },
  'kudali.in': {
    clientId: 12,
    villageName: 'कुडली',
    englishName: 'Kudali',
    theme: { primaryColor: '#839918', lightBg: '#F2F4E6', darkColor: '#374200' }
  },
  'kutgiri.in': {
    clientId: 13,
    villageName: 'कुटगिरी',
    englishName: 'Kutgiri',
    theme: { primaryColor: '#789918', lightBg: '#F1F4E6', darkColor: '#314200' }
  },
  'kolvali.in': {
    clientId: 14,
    villageName: 'कोळवली',
    englishName: 'Kolvali',
    theme: { primaryColor: '#6E9918', lightBg: '#EFF4E6', darkColor: '#2C4200' }
  },
  'kotaluk.in': {
    clientId: 15,
    villageName: 'कोतळूक',
    englishName: 'Kotaluk',
    theme: { primaryColor: '#639918', lightBg: '#EEF4E6', darkColor: '#264200' }
  },
  'kondhar-kalsur.in': {
    clientId: 16,
    villageName: 'कौंढरकाळसुर',
    englishName: 'Kondhar-Kalsur',
    theme: { primaryColor: '#589918', lightBg: '#EDF4E6', darkColor: '#214200' }
  },
  'khodade.in': {
    clientId: 17,
    villageName: 'खोडदे',
    englishName: 'Khodade',
    theme: { primaryColor: '#4E9918', lightBg: '#ECF4E6', darkColor: '#1B4200' }
  },
  'gimavi-devaghar.in': {
    clientId: 18,
    villageName: 'गिमवी-देवघर',
    englishName: 'Gimvi-Devgad',
    theme: { primaryColor: '#439918', lightBg: '#EBF4E6', darkColor: '#164200' }
  },
  'asgoli.in': {
    clientId: 19,
    villageName: 'असगोली',
    englishName: 'Asgoli',
    theme: { primaryColor: '#993818', lightBg: '#F4E9E6', darkColor: '#421000' }
  },
  'chindravale.in': {
    clientId: 20,
    villageName: 'चिंद्रवळे',
    englishName: 'Chindravale',
    theme: { primaryColor: '#2D9918', lightBg: '#E8F4E6', darkColor: '#0B4200' }
  },
  'janvale.in': {
    clientId: 21,
    villageName: 'जानवळे',
    englishName: 'Janvale',
    theme: { primaryColor: '#239918', lightBg: '#E7F4E6', darkColor: '#054200' }
  },
  'jamsut.in': {
    clientId: 22,
    villageName: 'जामसुत',
    englishName: 'Jamsut',
    theme: { primaryColor: '#189918', lightBg: '#E6F4E6', darkColor: '#004200' }
  },
  'zombadi.in': {
    clientId: 23,
    villageName: 'झोंबडी',
    englishName: 'Zombadi',
    theme: { primaryColor: '#189923', lightBg: '#E6F4E7', darkColor: '#004205' }
  },
  'talvali.in': {
    clientId: 24,
    villageName: 'तळवली',
    englishName: 'Talvali',
    theme: { primaryColor: '#18992D', lightBg: '#E6F4E8', darkColor: '#00420B' }
  },
  'dhopave-tetale.in': {
    clientId: 25,
    villageName: 'धोपावे-तेटले',
    englishName: 'Dhopave-Tetale',
    theme: { primaryColor: '#189938', lightBg: '#E6F4E9', darkColor: '#004210' }
  },
  'nigundal.in': {
    clientId: 26,
    villageName: 'निगुंडळ',
    englishName: 'Nigundal',
    theme: { primaryColor: '#189943', lightBg: '#E6F4EB', darkColor: '#004216' }
  },
  'parchuri.in': {
    clientId: 27,
    villageName: 'परचुरी',
    englishName: 'Parchuri',
    theme: { primaryColor: '#18994E', lightBg: '#E6F4EC', darkColor: '#00421B' }
  },
  'palshet.in': {
    clientId: 28,
    villageName: 'पालशेत',
    englishName: 'Palshet',
    theme: { primaryColor: '#189958', lightBg: '#E6F4ED', darkColor: '#004221' }
  },
  'pacheri-aagar.in': {
    clientId: 29,
    villageName: 'पाचेरीआगर',
    englishName: 'Pacheri-Aagar',
    theme: { primaryColor: '#189963', lightBg: '#E6F4EE', darkColor: '#004226' }
  },
  'pacheri-sada.in': {
    clientId: 30,
    villageName: 'पाचेरीसडा',
    englishName: 'Pacheri-Sada',
    theme: { primaryColor: '#18996E', lightBg: '#E6F4EF', darkColor: '#00422C' }
  },
  'palpene.in': {
    clientId: 31,
    villageName: 'पालपेणे',
    englishName: 'Palpene',
    theme: { primaryColor: '#189978', lightBg: '#E6F4F1', darkColor: '#004231' }
  },
  'grampanchayatpali.in': {
    clientId: 32,
    villageName: 'पाली',
    englishName: 'Pali',
    theme: { primaryColor: '#189983', lightBg: '#E6F4F2', darkColor: '#004237' }
  },
  'patpanhale.in': {
    clientId: 33,
    villageName: 'पाटपन्हाळे',
    englishName: 'Patpanhale',
    theme: { primaryColor: '#18998E', lightBg: '#E6F4F3', darkColor: '#00423C' }
  },
  'peve.in': {
    clientId: 34,
    villageName: 'पेवे',
    englishName: 'Peve',
    theme: { primaryColor: '#189999', lightBg: '#E6F4F4', darkColor: '#004242' }
  },
  'pomendi.in': {
    clientId: 35,
    villageName: 'पोमेंडी',
    englishName: 'Pomendi',
    theme: { primaryColor: '#188E99', lightBg: '#E6F3F4', darkColor: '#003C42' }
  },
  'pangaritarfhaveli.in': {
    clientId: 36,
    villageName: 'पांगारी तर्फे हवेली',
    englishName: 'Pangari Tarfe Haveli',
    theme: { primaryColor: '#188399', lightBg: '#E6F2F4', darkColor: '#003742' }
  },
  'pangaritarfvelamb.in': {
    clientId: 37,
    villageName: 'पांगारी तर्फे वेळंब',
    englishName: 'Pangari Tarfe Velamb',
    theme: { primaryColor: '#187899', lightBg: '#E6F1F4', darkColor: '#003142' }
  },
  'pimpar.in': {
    clientId: 38,
    villageName: 'पिंपर',
    englishName: 'Pimpar',
    theme: { primaryColor: '#186E99', lightBg: '#E6EFF4', darkColor: '#002C42' }
  },
  'bhatgaon.in': {
    clientId: 39,
    villageName: 'भातगाव',
    englishName: 'Bhatgaon',
    theme: { primaryColor: '#186399', lightBg: '#E6EEF4', darkColor: '#002642' }
    
  },
  'madhal.in': {
    clientId: 40,
    villageName: 'मढाळ',
    englishName: 'Madhal',
    theme: { primaryColor: '#185899', lightBg: '#E6EDF4', darkColor: '#002142' }
  },
  'malan.in': {
    clientId: 41,
    villageName: 'मळण',
    englishName: 'Malan',
    theme: { primaryColor: '#184E99', lightBg: '#E6ECF4', darkColor: '#001B42' }
  },
  'mundhar.in': {
    clientId: 42,
    villageName: 'मुंढर',
    englishName: 'Mundhar',
    theme: { primaryColor: '#184399', lightBg: '#E6EBF4', darkColor: '#001642' }
  },
  'grampanchayatranavi.in': {
    clientId: 43,
    villageName: 'रानवी',
    englishName: 'Ranavi',
    theme: { primaryColor: '#183899', lightBg: '#E6E9F4', darkColor: '#001042' }
  },
  'vadad.in': {
    clientId: 44,
    villageName: 'वडद',
    englishName: 'Vadad',
    theme: { primaryColor: '#182D99', lightBg: '#E6E8F4', darkColor: '#000B42' }
  },
  'varaveli.in': {
    clientId: 45,
    villageName: 'वरवेली',
    englishName: 'Varaveli',
    theme: { primaryColor: '#182399', lightBg: '#E6E7F4', darkColor: '#000542' }
  },
  'visapur.in': {
    clientId: 46,
    villageName: 'विसापुर',
    englishName: 'Visapur',
    theme: { primaryColor: '#181899', lightBg: '#E6E6F4', darkColor: '#000042' }
  },
  'grampanchayatmasu.in': {
    clientId: 47,
    villageName: 'मासु',
    englishName: 'Masu',
    theme: { primaryColor: '#231899', lightBg: '#E7E6F4', darkColor: '#050042' }
  },
  'veldur.in': {
    clientId: 48,
    villageName: 'वेलदुर',
    englishName: 'Veldur',
    theme: { primaryColor: '#2D1899', lightBg: '#E8E6F4', darkColor: '#0B0042' }
  },
  'velamb.in': {
    clientId: 49,
    villageName: 'वेळंब',
    englishName: 'Velamb',
    theme: { primaryColor: '#381899', lightBg: '#E9E6F4', darkColor: '#100042' }
  },
  'velneshwar.in': {
    clientId: 50,
    villageName: 'वेळणेश्वर',
    englishName: 'Velneshwar',
    theme: { primaryColor: '#431899', lightBg: '#EBE6F4', darkColor: '#160042' }
  },
  'shivane.in': {
    clientId: 51,
    villageName: 'शिवणे',
    englishName: 'Shivane',
    theme: { primaryColor: '#4E1899', lightBg: '#ECE6F4', darkColor: '#1B0042' }
  },
  'grampanchayatshir.in': {
    clientId: 52,
    villageName: 'शिर',
    englishName: 'Shir',
    theme: { primaryColor: '#581899', lightBg: '#EDE6F4', darkColor: '#210042' }
  },
  'sakhari-aagar.in': {
    clientId: 53,
    villageName: 'साखरीआगर',
    englishName: 'Sakhari-Aagar',
    theme: { primaryColor: '#631899', lightBg: '#EEE6F4', darkColor: '#260042' }
  },
  'sakhari-trishul.in': {
    clientId: 54,
    villageName: 'साखरी त्रिशुळ',
    englishName: 'Sakhari-Trishul',
    theme: { primaryColor: '#6E1899', lightBg: '#EFE6F4', darkColor: '#2C0042' }
  },
  'sakhari-budruk.in': {
    clientId: 55,
    villageName: 'साखरी बुद्रुक',
    englishName: 'Sakhari-Budruk',
    theme: { primaryColor: '#781899', lightBg: '#F1E6F4', darkColor: '#310042' }
  },
  'grampanchayatsural.in': {
    clientId: 56,
    villageName: 'सुरळ',
    englishName: 'Sural',
    theme: { primaryColor: '#831899', lightBg: '#F2E6F4', darkColor: '#370042' }
  },
  'sadejambhari.in': {
    clientId: 57,
    villageName: 'सडेजांभारी',
    englishName: 'Sadejambhari',
    theme: { primaryColor: '#8E1899', lightBg: '#F3E6F4', darkColor: '#3C0042' }
  },
  'grampanchayathedavi.in': {
    clientId: 58,
    villageName: 'हेदवी',
    englishName: 'Hedavi',
    theme: { primaryColor: '#991899', lightBg: '#F4E6F4', darkColor: '#420042' }
  },
  'kondkarul.in': {
    clientId: 59,
    villageName: 'कोंडकारुळ',
    englishName: 'Kondkarul',
    theme: { primaryColor: '#99188E', lightBg: '#F4E6F3', darkColor: '#42003C' }
  },
  'golewadi.in': {
    clientId: 60,
    villageName: 'गोळेवाडी',
    englishName: 'Golewadi',
    theme: { primaryColor: '#991883', lightBg: '#F4E6F2', darkColor: '#420037' }
  },
  'kosbiwadi.in': {
    clientId: 61,
    villageName: 'कोसबीवाडी',
    englishName: 'Kosbiwadi',
    theme: { primaryColor: '#991878', lightBg: '#F4E6F1', darkColor: '#420031' }
  },
  'naravan.in': {
    clientId: 62,
    villageName: 'नरवण',
    englishName: 'Naravan',
    theme: { primaryColor: '#99186E', lightBg: '#F4E6EF', darkColor: '#42002C' }
  },
  'palkottrishul.in': {
    clientId: 63,
    villageName: 'पालकोट त्रिशुळ',
    englishName: 'Palkot-Trishul',
    theme: { primaryColor: '#991863', lightBg: '#F4E6EE', darkColor: '#420026' }
  },
  'khamshet.in': {
    clientId: 64,
    villageName: 'खामशेत',
    englishName: 'Khamshet',
    theme: { primaryColor: '#991858', lightBg: '#F4E6ED', darkColor: '#420021' }
  },
  'pabhare.in': {
    clientId: 65,
    villageName: 'पाभरे',
    englishName: 'Pabhare',
    theme: { primaryColor: '#99184E', lightBg: '#F4E6EC', darkColor: '#42001B' }
  },
  'padave.in': {
    clientId: 66,
    villageName: 'पडवे',
    englishName: 'Padave',
    theme: { primaryColor: '#991843', lightBg: '#F4E6EB', darkColor: '#420016' }
  },
  // Add remaining 69 villages here...
  
  // Default fallback for development/unknown domains
  'localhost': {
    clientId: 1,
    villageName: 'चिखली',
    englishName: 'Chikhali',
    theme: { primaryColor: '#389918', lightBg: '#E9F4E6', darkColor: '#104200' },
    officeInfo: {
      officeName: 'ग्राम पंचायत कार्यालय',
      addressLine1: 'मु. पो. चिखली ता. गुहागर जि. रत्नागिरी',
      addressLine2: '',
      phones: ['+91 7219001956'],
      email: 'gp.chikhali1956@gmail.com',
      hours: ['सकाळी ९.१५ ते संध्याकाळी ६.१५'],
      imageUrl: 'office.jpg'
    }
  },
  'localhost:3000': {
    clientId: 1,
    villageName: 'चिखली',
    englishName: 'Chikhali',
    theme: { primaryColor: '#389918', lightBg: '#E9F4E6', darkColor: '#104200' },
    officeInfo: {
      officeName: 'ग्राम पंचायत कार्यालय',
      addressLine1: 'मु. पो. चिखली ता. गुहागर जि. रत्नागिरी',
      addressLine2: '',
      phones: ['+91 7219001956'],
      email: 'gp.chikhali1956@gmail.com',
      hours: ['सकाळी ९.१५ ते संध्याकाळी ६.१५'],
      imageUrl: 'office.jpg'
    }
  }
};

// Get current village configuration based on domain
export const getCurrentVillageConfig = () => {
  const hostname = window.location.hostname;
  const hostWithPort = window.location.host; // includes port for localhost
  
  // Remove 'www.' prefix if present
  const cleanHostname = hostname.replace(/^www\./, '');
  const cleanHostWithPort = hostWithPort.replace(/^www\./, '');
  
  console.log(`Determining village config for domain: ${cleanHostname} (host: ${cleanHostWithPort})`);
  
  // Try exact match first (with port for localhost)
  let config = VILLAGE_CONFIGS[cleanHostWithPort] || VILLAGE_CONFIGS[cleanHostname];
  
  // Fallback to default if domain not found
  if (!config) {
    console.warn(`Domain ${cleanHostname} not configured, using default clientId=1`);
    config = {
      clientId: 1,
      villageName: 'चिखली',
      englishName: 'Chikhali',
      theme: { primaryColor: '#389918', lightBg: '#E9F4E6', darkColor: '#104200' },
      officeInfo: {
        officeName: 'ग्राम पंचायत कार्यालय',
        addressLine1: 'मु. पो. चिखली ता. गुहागर जि. रत्नागिरी',
        addressLine2: '',
        phones: ['+91 7219001956'],
        email: 'gp.chikhali1956@gmail.com',
        hours: ['सकाळी ९.१५ ते संध्याकाळी ६.१५'],
        imageUrl: ''
      }
    };
  }
  
  return config;
};
// Get clientId for current domain
export const getCurrentClientId = () => {
  return getCurrentVillageConfig().clientId;
};

// Get village name for current domain
export const getCurrentVillageName = (language = 'en') => {
  const config = getCurrentVillageConfig();
  return language === 'mr' ? config.villageName : config.englishName;
};

// Get office information for current domain
export const getOfficeInfo = () => {
  const config = getCurrentVillageConfig();
  return config.officeInfo || {
    officeName: 'ग्राम पंचायत कार्यालय',
    addressLine1: '',
    addressLine2: '',
    phones: [],
    email: '',
    hours: ['सकाळी ९.४५ ते सायं. ०६.१५'],
    imageUrl: ''
  };
};

// Get theme for current village
export const getVillageTheme = (clientId) => {
  // Get the village config by clientId
  const config = getCurrentVillageConfig();
  
  // If the clientId matches, use that config's theme
  // Otherwise, find the config with matching clientId
  let villageTheme = config.clientId === clientId ? config.theme : null;
  
  if (!villageTheme) {
    // Search through all configs to find matching clientId
    for (const domain in VILLAGE_CONFIGS) {
      if (VILLAGE_CONFIGS[domain].clientId === clientId) {
        villageTheme = VILLAGE_CONFIGS[domain].theme;
        break;
      }
    }
  }
  
  // Fallback to default theme if not found
  if (!villageTheme) {
    console.warn(`Theme not found for clientId ${clientId}, using default theme`);
    villageTheme = { primaryColor: '#389918', lightBg: '#E9F4E6', darkColor: '#104200' };
  }
  
  return {
    primaryColor: villageTheme.primaryColor,
    lightBg: villageTheme.lightBg,
    darkColor: villageTheme.darkColor,
    gradient: `linear-gradient(179.95deg, ${villageTheme.lightBg} 45.48%, #FFFFFF 109.58%)`
  };
};

// API configuration
export const getApiConfig = () => {
  return {
    baseURL: process.env.REACT_APP_API_BASE_URL || 'https://innermap.in/api',
    clientId: getCurrentClientId()
  };
};

export default VILLAGE_CONFIGS;